import { z } from 'zod';

export const addBillableTimeReasonValidation = z.object({
  billableTimeReason: z.string().min(50, { message: 'Reason is required.' }),
});

export type addBillableTimeReasonValidationFormData = z.infer<
  typeof addBillableTimeReasonValidation
>;
